import React from 'react';
import { Col, Image } from 'react-bootstrap';
import theBook from '../../assets/images/book.png';

const Book = () => (
  <div className="main-book-grid">
    <Col md={6} className="first-book-grid">
      <Image className="book-for-desktop" src={theBook} responsive />
    </Col>
    <Col md={6} sm={12} className="second-book-grid">
      <Image className="book-for-tablet" src={theBook} responsive />
      <h2 className="book-h2-grid">Life in the Presence of God</h2>
      <p className="book-dr">Dr. Ken Boa</p>
      <p className="book-text">
        You don't have to read this book to use Presence, but it will introduce you to the ideas that are the catalyst
        for the set of exercises you encounter in Presence. When Ken Boa writes, “What I’m asking you to do will take no
        more than a second, but it will also take the rest of your life,” he knows that you’re both capable and called
        to live not only the next life in the presence of God, but also your present earthly existence. Boa writes that
        “it will be the most important, most fruitful, most enjoyable thing you do.”
      </p>

      <p className="book-text">
        Here’s what others have said about <em>Life in the Presence of God:</em>
      </p>

      <p className="book-text">
        “Ken Boa consistently reminds us that a truly biblical worldview is more than an academic exercise or simply
        having the right intellectual thoughts about God. It’s about knowing Him, who is the truth{' '}
        <span style={{ letterSpacing: 5 }}>...</span> Like everything Boa writes, this book will lead you more deeply
        into that reality and relationship.” <br />
        <strong>John Stonestreet</strong>, president, The Colson Center for Christian Worldview; cohost, Breakpoint
        Radio
      </p>

      <p className="book-text">
        “I long to experience more of God in this noisy and busy world, and Ken has provided a fresh, practical,
        biblical pathway filled with wisdom, insight, and theological depth.”
        <br />
        <strong>Chip Ingram</strong>, Living on the Edge
      </p>

      <p className="book-text">
        “Ah, at last, a modern mentor guides us into the ancient path of practicing the presence of God!”
        <br />
        <strong>Alicia Britt Chole</strong>, author of <em>The Sacred Slow</em>
      </p>

      <p className="book-text">
        “This book deserves a careful read and an even more productive reread. Expect to discover practical guidance to
        satisfy the deepest longings of the human soul.”
        <br />
        <strong>Larry Crabb</strong>, <em>NewWay Ministries</em>
      </p>
      <div className="book-button">
        <a href="https://kenboa.org/product/life-presence-god" target="_blank" rel="noopener noreferrer">
          buy now
        </a>
      </div>
    </Col>
  </div>
);

export default Book;



// WEBPACK FOOTER //
// ./src/components/Landing/Book.js